export const formatTime = (seconds) => {
  if (!isFinite(seconds) || isNaN(seconds)) {
    return '00:00';
  }

  const secs = Math.floor(seconds);
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  const remainingSeconds = secs % 60;

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

/**
 * تبدیل cues به فرمت SRT
 * از startSeconds/endSeconds یا startTime/endTime (string) استفاده می‌کند
 *
 * @param {Array} cues - آرایه cueها (از srt-parser-2)
 * @returns {string} محتوای SRT
 */
export const convertCuesToSRT = (cues) => {
  if (!cues || !Array.isArray(cues)) return "";

  return cues
    .map((cue, index) => {
      const id = index + 1;
      const startTime = formatSRTTime(
        cue.startSeconds || parseSRTTimeToSeconds(cue.startTime),
      );
      const endTime = formatSRTTime(
        cue.endSeconds || parseSRTTimeToSeconds(cue.endTime),
      );
      const text = cue.text || "";
      return `${id}\n${startTime} --> ${endTime}\n${text}\n`;
    })
    .join("\n");
};

/**
 * تبدیل زمان SRT (00:00:00,000 یا 00:00:00.000) به ثانیه
 */
export const parseSRTTimeToSeconds = (timeStr) => {
  if (!timeStr) return 0;
  if (typeof timeStr === "number") return timeStr;
  const parts = timeStr.split(/[:,.]/);
  if (parts.length >= 3) {
    return (
      parseInt(parts[0]) * 3600 +
      parseInt(parts[1]) * 60 +
      parseFloat(parts[2]) +
      (parts[3] ? parseInt(parts[3]) / 1000 : 0)
    );
  }
  return 0;
};

/**
 * تبدیل ثانیه به فرمت زمان SRT (00:00:00,000)
 */
export const formatSRTTime = (seconds) => {
  if (typeof seconds !== "number" || isNaN(seconds)) return "00:00:00,000";

  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  const ms = Math.floor((seconds % 1) * 1000);

  return `${hours.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")}:${secs.toString().padStart(2, "0")},${ms
    .toString()
    .padStart(3, "0")}`;
};